import { Theme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        mainWrapper: {
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            backgroundColor: theme.palette.background.default,
        },
        cardContainer: {
            display: "flex",
            padding: theme.spacing(9),
            borderRadius: theme.spacing(2),
            width: `calc(100% - ${theme.spacing(12)})`,
            maxHeight: `calc(100vh - ${theme.spacing(12)})`,
            overflowY: "auto",
            boxShadow: `0px 4px 6px 0px #0000000D, 0px 1px 4px 0px #0000001A, 0px 4px 4px 0px #00000012`,
        },
        cardTitle: {
            lineHeight: "24px",
            fontWeight: 600,
            paddingTop: theme.spacing(1.125),
        },
        cardContentContainer: {
            marginTop: theme.spacing(2.625),
        },
        title: {
            fontSize: 34,
            textAlign: "center",
            letterSpacing: 0.25,
            marginBottom: theme.spacing(4),
        },
        subtitle: {
            fontSize: 20,
            fontWeight: 600,
            textAlign: "center",
            letterSpacing: 0.15,
            marginBottom: theme.spacing(1),
        },
        intro: {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: "24px",
            color: theme.palette.secondary.main,
        },
        hub: {
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: theme.spacing(2),
            marginBottom: theme.spacing(2),
            "&:not(:last-child)": {
                borderBottom: `1px solid ${theme.palette.neutrals.light}`,
            },
            "& span": {
                color: theme.palette.text.disabled,
            },
        },
    })
);

export default useStyles;
